import { z } from 'zod';

export const languagePreferenceSchema = z.enum(['en', 'es', 'pt-BR']);

export const LanguagePreferences: Record<LanguagePreferenceSchemaType, string> = {
  en: 'English',
  es: 'Spanish',
  'pt-BR': 'Portuguese (Brazil)',
};

export type LanguagePreferenceSchemaType = z.infer<typeof languagePreferenceSchema>;

export const languagePreferenceDefaultValue: LanguagePreferenceSchemaType = 'pt-BR';
